import { createContext, useContext } from "react";
var ForcedState = /* @__PURE__ */ ((ForcedState2) => {
  ForcedState2["BUTTONS_HOVER"] = "BUTTONS_HOVER";
  ForcedState2["NEXT_BUTTON_HOVER"] = "NEXT_BUTTON_HOVER";
  ForcedState2["PREVIOUS_BUTTON_HOVER"] = "PREVIOUS_BUTTON_HOVER";
  ForcedState2["SUBMIT_BUTTON_HOVER"] = "SUBMIT_BUTTON_HOVER";
  ForcedState2["INPUT_FIELDS_HOVER"] = "INPUT_FIELDS_HOVER";
  ForcedState2["INPUT_FIELDS_FOCUS"] = "INPUT_FIELDS_FOCUS";
  ForcedState2["INPUT_FIELDS_ERROR"] = "INPUT_FIELDS_ERROR";
  return ForcedState2;
})(ForcedState || {});
const ForcedStateContext = createContext([]);
const useForcedState = () => useContext(ForcedStateContext) || [];
export {
  ForcedState,
  ForcedStateContext,
  useForcedState
};
//# sourceMappingURL=forced-state-context.js.map
